import { AppState } from '../types'

export const getError = (state: AppState) => state.error
